import { MARQUEE } from "@/data/content";
import { LogoMark } from "./Logo";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((m, i) => (
      <span key={m} className="flex items-center">
        <span className={`px-8 font-display text-5xl sm:text-7xl lg:text-8xl tracking-[-0.03em] whitespace-nowrap ${i % 2 ? "text-outline" : "text-[var(--foam)]"}`}>{m}</span>
        <LogoMark className="h-8 sm:h-12 w-auto shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 py-10 sm:py-14">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
